<template>
    <app-layout title="Koš">

        <div class="d-none bg-green-100 bg-red-100 bg-white bg-yellow-100"></div> <!-- compile green -->

        <MessagesTable v-if="messages.length > 0" type="trash" :messages="messages" @refreshMessages="refreshMessages"/>

        <MessagesTableNoMessages v-else/>

        <p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p>

    </app-layout>

</template>

<script>
import AppLayout from "@/Layouts/AppLayout";
import { Link } from '@inertiajs/inertia-vue3'
import { useToast } from "vue-toastification";
import MessagesTable from "../Components/MessagesTable";
import MessagesTableNoMessages from "../Components/MessagesTableNoMessages";
export default {
    name: "Trash",
    components: {MessagesTableNoMessages, MessagesTable, AppLayout, InertiaLink: Link},
    data() {
        return {
            statuses: this.$page.props.statuses,
            messages: this.$page.props.messages,
            page: this.$page.props.page,
            search: this.$page.props.search,
            maxPage: this.$page.props.maxPage,
            directions: this.$page.props.directions,

            activePage: this.$page.props.activePage,
            settings: this.$page.props.settings,

            refreshMessagesInterval: null,

            showMessageOptions: null
        }
    },
    setup(){
        const toast = useToast();
        return { toast }
    },
    mounted(){
        this.setUpEcho();
    },
    unmounted(){
        this.destroyEcho();
    },

    methods: {
        setUpEcho(){
            console.log('stup up echo trash')
            Echo.private('App.Models.User.' + this.$page.props.user.id)
                .listen('MessagesChanged', (e) => {
                    console.log('MessagesChanged', e);
                    this.refreshMessages();
                })
        },
        destroyEcho(){
            console.log('destroy up echo trash')
            Echo.leave('App.Models.User.'+this.$page.props.user.id);
        },
        refreshMessages(){
            axios.get(route('fapi.messages', {direction: 2, page: this.page, search: this.search, manual: 0, longterm: this.activePage === 'longtermsent' ? 1 : 0, trashed: true}))
                .then(response => {
                    if(response.status === 200)
                        this.messages = response.data.messages;
                        this.page = response.data.page;
                        this.maxPage = response.data.maxPage;
                });
        },
    }
}
</script>

<style scoped>

</style>
